import { useConfigCat } from "../services/featureFlagProvider";
import { FEATURE_FLAGS, FlagsStatus } from "../utils/configCatUtils";

export type AffiliateDestinationsConfig = {
  [key: string]: string[];
};

export function useFeatureFlag<T>(flagName: string, defaultValue: T): T {
  const configCat = useConfigCat();

  if (!configCat?.flagValues || configCat.flagValues.size === 0) {
    return defaultValue;
  }

  return (configCat.flagValues.get(flagName) as T) ?? defaultValue;
}

export function useAffiliateDestinationConfigs(): AffiliateDestinationsConfig {
  return JSON.parse(
    useFeatureFlag<string>(FEATURE_FLAGS.AFFILIATE_DESTINATIONS, "{}"),
  );
}

export function useKatchForEligibility(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.USE_KATCH_FOR_ELIGIBILITY, false);
}

export function useAreFlagsLoading(): boolean {
  const configCat = useConfigCat();
  return configCat?.status === FlagsStatus.LOADING;
}
